export const parseInputValue = (value) => isNaN(value) || value === 0 ? '' : value.toString()
export const parseEventValue = (e) => {
    const output = parseInt(e.target.value, 10)
    return isNaN(output) ? 0 : output
}